import React from "react";
import { Paper } from "@material-ui/core";
import { IDocumentEvent } from "types";

const defaultTimelineSteps = [
  { id: 1, label: "Creado por:" },
  { id: 2, label: "Aprobación Supervisor:" },
  { id: 3, label: "Aprobación Coordinación Contable" },
  { id: 4, label: "Aprobación Contador General" },
  { id: 5, label: "Aprobación Recursos Humanos" },
];

const timelineStepsDocument12 = [
  { id: 1, label: "Creado por:" },
  { id: 2, label: "Aprobación Supervisor:" },
  { id: 3, label: "Aprobación Coordinación Contable" },
  { id: 4, label: "Aprobación Contador General" },
];
interface Props {
  currentStep?: number;
  creador?: string;
  aprobador?: string;
  aprobadorId?: number;
  events?: IDocumentEvent[]
  documentType: number
  flow: number
}

export const StepTimeline = ({ currentStep = 1, creador, aprobador, events, documentType, flow, aprobadorId }: Props) => {

  React.useEffect(() => {
  }, [currentStep, creador, aprobador, events, documentType]);

  // ===== NUMERO DE PASOS ====
  const baseTimelineSteps = timelineStepsDocument12;

  const timelineSteps =
    aprobadorId === 0
      ? baseTimelineSteps.filter(step => step.id !== 2)
      : baseTimelineSteps;


  // ===== CREADOR =====
  let creadorFinal = creador;

  if (!creador || creador === "Desconocido") {
    const creatorEvent = events?.find(
      (event) => event.historyTypeId === 1
    );

    creadorFinal = creatorEvent?.userName || "Desconocido";
  }

  // ===== APROBADOR =====
  let aprobadorFinal = aprobador;

  if (!aprobador || aprobador === "Desconocido") {

    // Primero buscar 118
    let approverEvent = events?.find(
      (event) => event.historyTypeId === 118
    );

    // Si no existe 118, buscar 117
    if (!approverEvent) {
      approverEvent = events?.find(
        (event) => event.historyTypeId === 117
      );
    }

    aprobadorFinal = approverEvent?.userName || "Desconocido";
  }

  // ===== FLOW 4 - STEP DINÁMICO POR EVENTOS =====
  let forcedActiveStep: number | null = null;

  if (flow === 4 && events?.length) {

    if (events.some(event => event.historyTypeId === 124)) {
      forcedActiveStep = 5;
    } else if (events.some(event => event.historyTypeId === 123)) {
      forcedActiveStep = 4;
    } else if (events.some(event => event.historyTypeId === 122)) {
      forcedActiveStep = 3;
    } else if (events.some(event => event.historyTypeId === 118)) {
      forcedActiveStep = 2;
    }
  }

  const calculatedStep = forcedActiveStep ?? currentStep;

  const maxStepId = Math.max(...timelineSteps.map(step => step.id));

  const activeStep = Math.min(
    Math.max(Math.round(calculatedStep), 1),
    maxStepId
  );

  return (
    <Paper
      variant="outlined"
      elevation={1}
      style={{
        padding: "16px",
        borderRadius: "12px",
        backgroundColor: "#f9f9f9",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <div className="flex items-center w-full">
        {timelineSteps.map((step, index) => {
          const allCompleted = flow === 6;
          const isCompleted = allCompleted || step.id < activeStep;
          const isActive = !allCompleted && step.id === activeStep;
          const isLast = index === timelineSteps.length - 1;
          const isFlow4ActiveStep =
            flow === 4 &&
            step.id === activeStep;

          const circleClasses = `
  flex items-center justify-center
  rounded-full w-9 h-9 md:w-10 md:h-10
  text-sm md:text-base font-bold
  transition-all duration-500 ease-in-out
  ${isCompleted
              ? "bg-gradient-to-r from-yellow-500 to-yellow-500 text-gray-800 shadow-md"
              : isActive
                ? isFlow4ActiveStep
                  ? "bg-red-500 text-white shadow-md ring-2 ring-red-200"
                  : "bg-white border-2 border-red-500 text-red-600 shadow-md ring-2 ring-red-200"
                : "bg-white border-2 border-gray-300 text-gray-400"
            }
`;

          let stepName: string | undefined;
          if (step.id === 1) stepName = creadorFinal;
          if (step.id === 2) stepName = aprobadorFinal;

          let labelLines: string[] = [];
          if (step.id >= 3 && step.label.includes("Aprobación")) {
            labelLines = step.label.split("Aprobación").filter(Boolean).map(s => s.trim());
            labelLines.unshift("Aprobación");
          } else {
            labelLines = [step.label];
          }

          return (
            <React.Fragment key={step.id}>
              <div className="flex-none flex flex-col items-center relative">
                <div className={circleClasses}>
                  {(isCompleted || isActive || allCompleted) ? (
                    <span className="text-gray-800">{step.id}</span>
                  ) : (
                    step.id
                  )}
                </div>

                <p
                  className={`mt-1 text-xs font-medium text-center
                    ${isActive ? "text-black-600 font-semibold" : isCompleted ? "text-black-600" : "text-gray-500"}`}
                >
                  {labelLines.map((line, i) => (
                    <span key={i} className="block">
                      {line}
                    </span>
                  ))}
                  {stepName && <span className="block text-xs text-gray-700 font-normal">{stepName}</span>}
                </p>
              </div>

              {!isLast && (
                <div className="flex-1 min-w-0 px-1">
                  <div className="relative h-1 w-full bg-gray-300 rounded-full overflow-hidden">
                    <div
                      className="absolute top-0 left-0 h-1 rounded-full transition-all duration-700 ease-in-out"
                      style={{
                        width:
                          isCompleted
                            ? "100%"
                            : isFlow4ActiveStep
                              ? "0%"
                              : isActive
                                ? "50%"
                                : "0%",
                        background:
                          isCompleted || isActive
                            ? "linear-gradient(to right, #efe444, #fa8415)" // rojo → amarillo
                            : "#E5E7EB",
                      }}
                    />
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </Paper>
  );
};